import { getCurrentStoreConfig } from "../tenant";

export interface AuthInfo {
  token: string | null;
  user: any | null;
  isLoggedIn: boolean;
}

const currentStore = getCurrentStoreConfig();
export const BRAND_NAME = currentStore?.name || process.env.REACT_APP_BRAND_NAME || "Vtech";

export function cleanUrl(url: string) {
  if (!url) return "";
  try {
    let decoded = decodeURIComponent(url);

    decoded = decoded.replace(/\\/g, "/");

    decoded = decoded.trim();

    return decoded;
  } catch (e) {
    console.error("Invalid URL:", url, e);
    return url;
  }
}

export function toSlug(str: string) {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .replace(/[^a-zA-Z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .toLowerCase();
}

export function getUser() {
  try {
    const data = localStorage.getItem("user");
    if (!data) return null;
    return JSON.parse(data);
  } catch {
    return null;
  }
}

export function isAuthenticated(): AuthInfo {
  if (typeof window === "undefined") {
    return { token: null, user: null, isLoggedIn: false };
  }

  const user = getUser();

  return {
    token: user?.token || null,
    user,
    isLoggedIn: !!user?.token,
  };
}

export function getUserStatus(): boolean {
  if (typeof window === "undefined") return false;

  const user = getUser();
  return !!user?.token;
}

export function getUserMessage(): string {
  const user = getUser();

  if (!user) return "";

  switch (user.customerType) {
    case 0:
      return "Bạn đang đăng nhập bằng tài khoản khách lẻ";
    case 1:
      return "Bạn đang đăng nhập bằng tài khoản khách Spa";
    case 2:
      return "Bạn đang đăng nhập bằng tài khoản đại lý";
    case 3:
      return "Bạn đang đăng nhập bằng tài khoản đại lý";
    default:
      return "";
  }
}
